import { createAsyncThunk } from '@reduxjs/toolkit';

import { eventService } from '../../services/event.service';
import { type } from './state';
import { ApiResponse } from '../../models';
import { createClearAllAsyncThunk, createClearErrorAsyncThunk } from '../shared-actions';

export const getAllUpcomingEvents = createAsyncThunk<ApiResponse, { customerId: number }>(
    `${type}/getAllUpcomingEvents`,
    async (args, { rejectWithValue }) => {
        try {
            return await eventService.getUpcomingForCustomer(args.customerId);
        } catch (error) {
            return rejectWithValue(error);
        }
    }
);

export const clearErrorsAction = createClearErrorAsyncThunk(type);
export const clearAllAction = createClearAllAsyncThunk(type);
